import ProductEventsDataSource from './ProductEventsDataSource'

export default {
  install( molten ) {
    const dataSource = new ProductEventsDataSource()
    molten.addPlugin( 'DataSource', { type : 'product.event', dataSource } )
  }
}
